import * as React from "react";

function Copy(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                d="M18.835 5V16C18.835 17.6569 17.4918 19 15.835 19H4.83496M3.83496 15H11.835C13.4918 15 14.835 13.6569 14.835 12V4C14.835 2.34315 13.4918 1 11.835 1H3.83496C2.17811 1 0.834961 2.34315 0.834961 4V12C0.834961 13.6569 2.17811 15 3.83496 15Z"
                stroke="white"
                strokeWidth="1.62"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Copy;
